"use client";

import posthog from "posthog-js";
import { PostHogProvider as PHProvider } from "posthog-js/react";
import { useEffect } from "react";

export function PostHogProvider({ children }: { children: React.ReactNode }) {
  useEffect(() => {
    posthog.init(process.env.NEXT_PUBLIC_POSTHOG_KEY!, {
      api_host: process.env.NEXT_PUBLIC_POSTHOG_HOST,
      ui_host: "https://us.posthog.com",
      person_profiles: "identified_only",
      capture_pageview: false, // We handle this manually with PostHogPageView
      capture_pageleave: true,
      defaults: "2026-01-30",

      // ─── Error Tracking ────────────────────────────────────────────────
      // Automatically capture unhandled errors, promise rejections, and
      // console.error() calls so every crash lands in PostHog Error Tracking.
      capture_exceptions: {
        capture_unhandled_errors: true,      // window.onerror
        capture_unhandled_rejections: true,  // unhandled promise rejections
        capture_console_errors: true,        // console.error() calls
      },

      // ─── Session Replay ─────────────────────────────────────────────────
      // 10% sample rate — suitable for our multi-tenant platform scale.
      // Increase via PostHog dashboard settings once you want more coverage.
      session_recording: {
        maskAllInputs: true,           // Hide passwords, card numbers, etc.
        maskTextSelector: "[data-mask]", // Add data-mask to any sensitive element
      },
    });
  }, []);

  return <PHProvider client={posthog}>{children}</PHProvider>;
}
